// Module COLIS
export const COLIS_SET_COLIS = 'COLIS_SET_COLIS'
export const COLIS_SET_PRODUITS = 'COLIS_SET_PRODUITS'
export const COLIS_ADD_PRODUIT = 'COLIS_ADD_PRODUIT'
export const COLIS_SET_PAYS = 'COLIS_SET_PAYS'

// Module UI
export const UI_SET_EDIT = 'UI_SET_EDIT'